import { Mail, Phone, MapPin } from 'lucide-react';
import { FaTiktok, FaLinkedinIn } from 'react-icons/fa';
import { GrInstagram } from 'react-icons/gr';
import { Link } from 'react-router-dom';
import logo from '/logo-400.webp';
import { useSmoothScroll } from '@/hooks/useSmoothScroll';

export function Footer() {
  const currentYear = new Date().getFullYear()
  const { handleNavClick } = useSmoothScroll();

  return (
    <footer className="bg-background border-t border-border/30">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div onClick={() => handleNavClick('home')} className="cursor-pointer inline-block" aria-label="Gå til toppen av siden">
              <img
                src={logo}
                srcSet="/logo-200.webp 200w, /logo-400.webp 400w"
                sizes="(max-width: 768px) 200px, 400px"
                alt="Pyksel Logo"
                className="h-12 w-auto"
                width="180"
                height="48"
                loading="lazy"
              />
            </div>
            <p className="text-muted-foreground mb-6 max-w-md">
              Vi skaper visuell magi som fanger oppmerksomhet og bygger merkevarer 
              som folk elsker. La oss hjelpe deg å realisere ditt fulle potensial.
            </p>
            
            {/* Social Links */}
            <div className="flex space-x-4">
              <a href="https://instagram.com/pyksel.no" target="_blank" rel="noopener noreferrer" aria-label="Følg oss på Instagram" className="w-10 h-10 rounded-lg bg-muted/50 flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-colors">
                <GrInstagram className="w-5 h-5" />
              </a>
              <a href="#" aria-label="Følg oss på LinkedIn" className="w-10 h-10 rounded-lg bg-muted/50 flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-colors">
                <FaLinkedinIn className="w-5 h-5" />
              </a>
              <a href="#" aria-label="Følg oss på Tiktok" className="w-10 h-10 rounded-lg bg-muted/50 flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-colors">
                <FaTiktok className="w-5 h-5" />
              </a>
            </div>
          </div>


          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">Kontakt</h4>
            <ul className="space-y-3 text-muted-foreground">
              <li className="flex items-center space-x-2">
                <Mail className="w-4 h-4" />
                <a href="mailto:kontakt@pyksel.no" className="hover:text-primary transition-colors">kontakt@pyksel.no</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-border/30 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-muted-foreground">
            © {currentYear} Pyksel. Alle rettigheter reservert.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/personvern" className="text-muted-foreground hover:text-primary transition-colors">
              Personvern
            </Link>
            <Link to="/vilkar" className="text-muted-foreground hover:text-primary transition-colors">
              Vilkår
            </Link>
            <Link to="/cookies" className="text-muted-foreground hover:text-primary transition-colors">
              Cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
